var exports = {
  "a": "Box__tNUPjX",
  "C": "disabledFooter__rD2n84",
};

module.exports = exports;
